export type Either<ERROR_TYPE, VALUE_TYPE> = Left<ERROR_TYPE> | Right<VALUE_TYPE>;

export class Left<ERROR_TYPE> {
    readonly error: ERROR_TYPE

    private constructor(error: ERROR_TYPE) {
        this.error = error
    }

    isLeft(): this is Left<ERROR_TYPE> {
        return true
    }

    isRight(): this is Right<never> {
        return false
    }

    static create<ERROR_TYPE>(error: ERROR_TYPE): Left<ERROR_TYPE> {
        return new Left(error)
    }
}

export class Right<VALUE_TYPE> {
    readonly value: VALUE_TYPE

    private constructor(value: VALUE_TYPE) {
        this.value = value
    }

    isLeft(): this is Left<never> {
        return false
    }

    isRight(): this is Right<VALUE_TYPE> {
        return true
    }

    static create<VALUE_TYPE>(value: VALUE_TYPE): Right<VALUE_TYPE> {
        return new Right(value)
    }
}